/**
 * Audit log (S34) — append-only event explorer.
 * @see prototype/admin/audit-log.html — V1.1 audit-log baseline
 * @see docs/spec/08-system-decisions.md §3 — audit trail scope and retention
 */
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { AuditLogPage } from "../../../../features/audit-log/index.ts";
import { usePermission } from "../../../../lib/permissions.ts";
import "../../../../features/audit-log/audit-log.css";

export const Route = createFileRoute("/(workspace)/records/audit-log/")({
  component: AuditLogRoute,
});

function AuditLogRoute() {
  const canView = usePermission("audit.view");
  if (!canView) {
    return (
      <WorkspaceShell
        breadcrumbs={[{ label: "Compliance" }, { label: "Audit log" }]}
        contentClassName="max-w-[1380px]"
      >
        <div className="flex flex-col items-center justify-center gap-3 py-24 text-center text-muted">
          <ClipboardList size={36} className="opacity-30" />
          <p className="text-sm font-medium">You don't have access to Audit log.</p>
          <p className="text-xs">Ask a Founder to grant you the <em>audit.view</em> permission.</p>
        </div>
      </WorkspaceShell>
    );
  }
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Compliance" }, { label: "Audit log" }]}
      contentClassName="max-w-[1380px]"
    >
      <AuditLogPage />
    </WorkspaceShell>
  );
}
